var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 351,
    viewBox: "0 0 346 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_565)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.038,
    cy: 245.177,
    rx: 93.2278,
    ry: 26.0247,
    fill: "#BDBABA",
    fillOpacity: 0.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_565)",
    filter: "url(#filter1_dd_0_565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.059,
    height: 145.607,
    transform: "matrix(0.978574 0.205894 -0.502294 0.864697 200.386 81.4517)",
    fill: "url(#paint0_linear_0_565)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.001 104.936L200.386 81.4517L127.249 207.357L238.864 230.841L312.001 104.936ZM212.676 89.9248C206.774 88.683 199.534 91.9041 196.504 97.1193L140.432 193.647C137.403 198.862 139.732 204.096 145.634 205.338L226.574 222.368C232.476 223.61 239.716 220.389 242.746 215.174L298.818 118.646C301.847 113.431 299.519 108.197 293.617 106.955L212.676 89.9248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.37 146.216C247.21 151.126 243.484 158.008 236.578 161.186L212.692 172.13C211.189 172.852 209.498 172.496 209.069 171.368L201.716 153.851C199.605 148.775 203.815 141.995 211.119 139.22C217.489 136.808 223.719 138.837 225.596 143.384L226.379 145.146L228.736 144.045C234.991 141.209 241.884 141.941 244.37 146.216Z",
    fill: "url(#paint1_linear_0_565)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_565)",
    filter: "url(#filter4_dd_0_565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.059,
    height: 145.607,
    transform: "matrix(0.949096 -0.314987 0.387033 0.922066 41 51.9269)",
    fill: "url(#paint2_linear_0_565)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_0_565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.253 16L41 51.9269L97.3546 186.186L205.607 150.259L149.253 16ZM58.2236 52.5843C52.4994 54.484 49.7513 60.5323 52.0856 66.0935L95.2907 169.025C97.625 174.587 104.158 177.555 109.882 175.655L188.384 149.602C194.108 147.702 196.856 141.654 194.522 136.092L151.317 33.1605C148.983 27.5993 142.45 24.6311 136.726 26.5309L58.2236 52.5843Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_0_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.667 81.267C140.306 83.7316 143.598 90.9379 141.072 96.7899L132.294 116.992C131.771 118.29 130.131 118.834 128.78 118.159L107.261 108.011C101.041 105.062 98.2182 97.6999 101.418 91.97C104.216 86.9785 110.905 85.5364 116.466 88.1861L118.664 89.1853L119.511 87.1754C121.837 81.9082 127.876 79.1262 133.667 81.267Z",
    fill: "url(#paint3_linear_0_565)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_565",
    x: 0.484589,
    y: 139.826,
    width: 345.107,
    height: 210.701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.663,
    result: "effect1_foregroundBlur_0_565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_0_565",
    x: 110.908,
    y: 66.4298,
    width: 209.261,
    height: 173.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.61197,
    dy: -3.29427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.8638
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.922969 0 0 0 0 0.920293 0 0 0 0 0.920293 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.97656,
    dy: 2.63541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.09661
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_565",
    result: "effect2_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_565",
    x: 125.631,
    y: 79.8338,
    width: 188.797,
    height: 153.434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.404463,
    dy: 0.404463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01116
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_565",
    x: 177.19,
    y: 125.223,
    width: 85.1079,
    height: 67.8077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.63541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.66614
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.982523 0 0 0 0 0.515133 0 0 0 0 0.65599 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_0_565",
    x: 24.6604,
    y: 0.978141,
    width: 189.116,
    height: 194.036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.61197,
    dy: -3.29427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.8638
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.922969 0 0 0 0 0.920293 0 0 0 0 0.920293 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.97656,
    dy: 2.63541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.09661
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_565",
    result: "effect2_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_0_565",
    x: 39.3821,
    y: 14.3821,
    width: 168.652,
    height: 174.23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.404463,
    dy: 0.404463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01116
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_0_565",
    x: 81.8334,
    y: 64.1553,
    width: 83.7481,
    height: 79.5705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.63541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.225257 0 0 0 0 0.788755 0 0 0 0 0.923995 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_565",
    x1: 57.0293,
    y1: 0,
    x2: 57.0293,
    y2: 145.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FBA8C1",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA8C1",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_565",
    x1: 229.01,
    y1: 140.539,
    x2: 190.43,
    y2: 323.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E8E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_565",
    x1: 57.0293,
    y1: 0,
    x2: 57.0293,
    y2: 145.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A2E3F3",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2E3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_565",
    x1: 116.567,
    y1: 84.295,
    x2: 178.538,
    y2: 271.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.190891,
    stopColor: "#A2E3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.059,
    height: 145.607,
    fill: "white",
    transform: "matrix(0.978574 0.205894 -0.502294 0.864697 200.385 81.4517)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.059,
    height: 145.607,
    fill: "white",
    transform: "matrix(0.949096 -0.314987 0.387033 0.922066 41 51.9269)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatched);
export default __webpack_public_path__ + "static/media/matched.fde2a54445f85495dbb74824c9d41cf1.svg";
export { ForwardRef as ReactComponent };